import { StyleSheet } from 'react-native'
import { color, fontFamily } from '../../../../../theme'

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingVertical: 10,
    gap: 20,
    borderBottomColor: color.palette.lightGrey,
    borderBottomWidth: 1
  },
  userSection: {
    flex: 1,
    flexDirection: 'row',
    gap: 10
  },
  text: {
    textAlign: 'center',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontSize: 16,
    lineHeight: 19.2,
    letterSpacing: -0.25
  },
  textBold: {
    fontWeight: '500'
  },
  avatar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  userName: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '50%'
  },
  userNameContent: {
    flex: 1,
    gap: 2,
    alignItems: 'center'
  },
  userNameText: {
    fontWeight: '400',
    textAlign: 'center'
  },
  metaText: {
    textAlign: 'center',
    fontSize: 13,
    lineHeight: 16
  }
})
